import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Scrollbars } from "react-custom-scrollbars";

const Sidebar = (props) => {
  const [isSideMenu, setSideMenu] = useState("");
  // const refs = useRef([]);

  useEffect(() => {
    console.log("nestedMenu");
    document.querySelectorAll(".btnExpand").forEach((button) => {
      button.addEventListener("click", function () {
        document.querySelectorAll(".down-arrow").forEach((btnExpand) => {
          if (
            btnExpand.classList.contains("rotate-0") &&
            !btnExpand.classList.contains("has-main")
          ) {
            btnExpand.classList.toggle("rotate-0");
          }
        });
        document.querySelectorAll(".has-sub-menu").forEach((hasSubMenu) => {
          if (!hasSubMenu.classList.contains("hidden")) {
            hasSubMenu.classList.toggle("hidden");
          }
        });
        const nestedMenu = this.nextElementSibling;
        if (nestedMenu) {
          nestedMenu.classList.toggle("hidden");
          this.querySelector(".down-arrow").classList.toggle("rotate-0");
        }
      });
    });
  }, []);

  useEffect(() => {
    function handleMouseOver(e) {
      e.stopPropagation();
      if (
        document.querySelector("#toggle_btn") &&
        document.body.classList.contains("mini-sidebar") &&
        document.querySelector("#toggle_btn").offsetParent !== null
      ) {
        var targ = e.target.closest(".sidebar");
        if (targ) {
          document.body.classList.add("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "block"));
        } else {
          document.body.classList.remove("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "none"));
        }
        return false;
      }
    }

    document.addEventListener("mouseover", handleMouseOver);
    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  const location = useLocation();
  console.log("Working", location.pathname);

  // Add id to selectedItems
  const handleClick = (id) => {
    console.log(id);
    // if (refs.current) console.log(refs.current[id]);
    // const element = refs.current[id];
    // if (element) {
    //   element.addEventListener("click", function () {
    //     const nestedMenu = this.nextElementSibling;
    //     if (nestedMenu) {
    //       nestedMenu.classList.toggle("hidden");
    //       this.querySelector(".down-arrow").classList.toggle("rotate-0");
    //     }
    //   });
    // }
  };

  return (
    <>
      <div className="sidebar" id="sidebar">
        <div className="h-12 w-full float-left px-6 justify-start title-hidden mb-3">
          <div className="sidebar-logo">
            <Link to="/index">
              <img className="img-fluid logo" alt="" />
            </Link>
            <Link to="index">
              <img className="img-fluid logo-small" alt="" />
            </Link>
          </div>
        </div>
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul className="text-sm list-none m-0 relative mt-1">
                {/* <li id="sidebar-menu" className="text-gray-500 text-sm opacity-100 px-5 py-2 whitespace-nowrap">
                  <span>General</span>
                </li> */}
                <li
                  className={`${
                    "/dashboard" === location.pathname ||
                    "/index" === location.pathname
                      ? "active mb-3 relative"
                      : "mb-3 relative"
                  }`}
                >
                  <Link
                    to="/dashboard"
                    className={`subdrop px-4 py-3 relative text-gray-500 flex content-between`}
                  >
                    <FeatherIcon className="w-4" icon="home" />
                    <span className="py-0 px-2 text-sm font-normal text-gray-500 leading-5">
                      Dashboard
                    </span>
                  </Link>
                </li>

                <li
                  className={`${
                    "/users" === location.pathname ||
                    "/active-customers" === location.pathname ||
                    "/deactive-customers" === location.pathname ||
                    "/edit-customer" === location.pathname ||
                    "/add-user" === location.pathname
                      ? "active mb-3 relative"
                      : "mb-3 relative"
                  }`}
                >
                  <Link
                    to="/users"
                    className="px-4 py-2 relative text-gray-500 flex"
                  >
                    <FeatherIcon className="w-4" icon="users" />
                    <span className="py-0 px-2 text-sm font-normal text-gray-500 leading-5">
                      Users
                    </span>
                  </Link>
                </li>

                <li
                  className={`${
                    "/company" === location.pathname ||
                    "/edit-company" === location.pathname ||
                    "/add-company" === location.pathname
                      ? "active mb-3 relative"
                      : "mb-3 relative"
                  }`}
                >
                  <Link
                    to="/company"
                    className="px-4 py-2 relative text-gray-500 flex"
                  >
                    <FeatherIcon className="w-4" icon="trello" />
                    <span className="py-0 px-2 text-sm font-normal text-gray-500 leading-5">
                      Company
                    </span>
                  </Link>
                </li>

                <li
                  className={`${
                    "/branch" === location.pathname ||
                    "/edit-branch" === location.pathname ||
                    "/add-branch" === location.pathname
                      ? "active mb-3 relative"
                      : "mb-3 relative"
                  }`}
                >
                  <Link
                    to="/branch"
                    className="px-4 py-2 relative text-gray-500 flex"
                  >
                    <FeatherIcon className="w-4" icon="trello" />
                    <span className="py-0 px-2 text-sm font-normal text-gray-500 leading-5">
                      Branch
                    </span>
                  </Link>
                </li>

                <li
                  className={`${
                    "/task-manager" === location.pathname ||
                    "/add-new-task" === location.pathname
                      ? "active mb-3 relative"
                      : "mb-3 relative"
                  }`}
                >
                  <Link
                    to="/task-manager"
                    className="px-4 py-2 relative text-gray-500 flex"
                  >
                    <FeatherIcon className="w-4" icon="file-text" />
                    <span className="py-0 px-2 text-sm font-normal text-gray-500 leading-5">
                      Task Manager
                    </span>
                  </Link>
                </li>

                <li className="mb-3 relative">
                  <Link className="btnExpand px-4 py-2 relative text-gray-500 flex">
                    <FeatherIcon className="w-4" icon="sliders" />
                    <span className="py-0 px-2 text-sm font-normal text-gray-500 leading-5">
                      Master
                    </span>
                    <FeatherIcon
                      className="down-arrow w-4 rotate-90 has-main"
                      icon="chevron-down"
                    />
                  </Link>
                  <ul className="pl-4 mt-2 space-y-1 bg-gray-50 hidden">
                    <li>
                      <Link className="btnExpand px-4 py-2 relative text-gray-500 flex">
                        <FeatherIcon className="w-4" icon="cpu" />
                        <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                          Basic
                        </span>
                        <FeatherIcon
                          className="down-arrow w-4 rotate-90"
                          icon="chevron-down"
                        />
                      </Link>
                      <ul className="pl-4 mt-1 space-y-1 bg-gray-100 hidden has-sub-menu">
                        <li>
                          <Link className="px-4 py-2 relative text-gray-500 flex">
                            <FeatherIcon className="w-4" icon="sliders" />
                            <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                              Bubble Sort
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/branch"
                            className="px-4 py-2 relative text-gray-500 flex"
                          >
                            <FeatherIcon className="w-4" icon="sliders" />
                            <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                              Merge Sort
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link className="btnExpand px-4 py-2 relative text-gray-500 flex">
                        <FeatherIcon className="w-4" icon="globe" />
                        <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                          Service
                        </span>
                        <FeatherIcon
                          className="down-arrow w-4 rotate-90"
                          icon="chevron-down"
                        />
                      </Link>
                      <ul className="pl-4 mt-1 space-y-1 bg-gray-100 hidden has-sub-menu">
                        <li>
                          <Link
                            to="/branch"
                            className="px-4 py-2 relative text-gray-500 flex"
                          >
                            <FeatherIcon className="w-4" icon="sliders" />
                            <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                              Binary Search
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/branch"
                            className="px-4 py-2 relative text-gray-500 flex"
                          >
                            <FeatherIcon className="w-4" icon="sliders" />
                            <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                              Linear Search
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <Link className="btnExpand px-4 py-2 relative text-gray-500 flex">
                        <FeatherIcon className="w-4" icon="users" />
                        <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                          Employee
                        </span>
                        <FeatherIcon
                          className="down-arrow w-4 rotate-90"
                          icon="chevron-down"
                        />
                      </Link>
                      <ul className="pl-4 mt-1 space-y-1 bg-gray-100 hidden has-sub-menu">
                        <li>
                          <Link
                            to="/branch"
                            className="px-4 py-2 relative text-gray-500 flex"
                          >
                            <FeatherIcon className="w-4" icon="sliders" />
                            <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                              Binary Search
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/branch"
                            className="px-4 py-2 relative text-gray-500 flex"
                          >
                            <FeatherIcon className="w-4" icon="sliders" />
                            <span className="py-0 px-1 text-sm font-normal text-gray-500 leading-5">
                              Linear Search
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>

                <li className={`"mb-3 relative"`}>
                  <Link
                    to="/logout"
                    className="px-4 py-2 relative text-gray-500 flex"
                  >
                    <FeatherIcon className="w-4" icon="log-out" />
                    <span className="py-0 px-2 text-sm font-normal text-gray-500 leading-5">
                      Logout
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </Scrollbars>
        <div className="footer fixed h-12 bottom-0 px-4 justify-start title-hidden mt-3">
          <Link to="/index">TOLLP</Link>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
